import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Shell from '../../dashboard/Shell';
import Calculator from './Calculator';
import './CalculatorPage.css';

const CalculatorPage = () => {
  return (
    <Shell>
      <div className="rsc-calc-page">
        <header className="rsc-calc-page__head">
          <Link to="/overview" className="rsc-calc-page__back" aria-label="Back to overview">
            <ChevronLeft size={18} aria-hidden="true" />
            <span>Back</span>
          </Link>
          <div className="rsc-calc-page__title">
            <span className="rsc-calc-page__eyebrow">Utilities</span>
            <h1 className="rsc-calc-page__heading">Calculator</h1>
            <p className="rsc-calc-page__sub">Quick arithmetic with history. Works with your keyboard too.</p>
          </div>
        </header>

        <div className="rsc-calc-page__body">
          <div className="rsc-calc-page__card">
            <Calculator />
          </div>
        </div>
      </div>
    </Shell>
  );
};

export default CalculatorPage;
